import { render, staticRenderFns } from "./DashboardModalCard.vue?vue&type=template&id=2a7bc2a0&scoped=true&"
import script from "./DashboardModalCard.vue?vue&type=script&lang=js&"
export * from "./DashboardModalCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardModalCard.vue?vue&type=style&index=0&id=2a7bc2a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7bc2a0",
  null
  
)

export default component.exports